import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { ITeamMember } from '../../../../../../interfaces/professional/Professional';
import TeamMemberCard from '../../../../../Common/TeamMemberCard/TeamMemberCard';
import * as classes from './TeamMembersSection.module.scss';
import cn from 'classnames';
import { TeamMembersSectionProps } from '../../../../../Sections/AdditionalInfo/TeamMembersSection/TeamMembersSection';
import DefaultButton from '../../../Components/DefaultButton/DefaultButton';

const TeamMembersSection: FC<TeamMembersSectionProps> = ({ members }) => {
  const { t } = useTranslation();
  const teamMembersMapper = (item: ITeamMember, index: number) => (
    <div className='col-12 col-sm-6' key={index}>
      <TeamMemberCard {...item} />
    </div>
  );

  return (
    <Section number={'02'} label={t('additionalInfo.teamMembersSection.sectionTitle')} className={classes.wrapper}>
      <Container>
        <div className='row'>
          <div className='col-xl-5 col-lg-5 col-md-6 col-sm-5'>
            <SectionTitle>
              {members.length > 1
                ? t('additionalInfo.teamMembersSection.titleText')
                : t('additionalInfo.teamMembersSection.titleTextOneMember')}
            </SectionTitle>
            <div className='d-none d-sm-flex'>
              <DefaultButton
                link={{
                  title: t('additionalInfo.teamMembersSection.informationRequestButton.linkTitle'),
                  path: t('additionalInfo.teamMembersSection.informationRequestButton.buttonLink'),
                }}
              >
                {t('additionalInfo.teamMembersSection.informationRequestButton.buttonText')}
              </DefaultButton>
            </div>
          </div>
          <div className='col-xl-7 col-lg-7 col-md-6 col-sm-7'>
            <div className={cn('row', members.length > 1 && classes.membersRow)}>{members.map(teamMembersMapper)}</div>
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default TeamMembersSection;
